import { render, staticRenderFns } from "./TestInvitations.vue?vue&type=template&id=2519ab97&"
import script from "./TestInvitations.vue?vue&type=script&lang=js&"
export * from "./TestInvitations.vue?vue&type=script&lang=js&"
import style0 from "./TestInvitations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports